/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Teaseruploadsuccess3Inputs */

const en_coinvestments_teaseruploadsuccess3 = /** @type {(inputs: Coinvestments_Teaseruploadsuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaser document uploaded successfully`)
};

/**
* | output |
* | --- |
* | "Teaser document uploaded successfully" |
*
* @param {Coinvestments_Teaseruploadsuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_teaseruploadsuccess3 = /** @type {((inputs?: Coinvestments_Teaseruploadsuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Teaseruploadsuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_teaseruploadsuccess3(inputs)
});
export { coinvestments_teaseruploadsuccess3 as "coInvestments_teaserUploadSuccess" }